var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getServiceQualification from './getServiceQualification';
import { messageRotator } from './helperFunctions';
import checkServicesAvailable from './checkServicesAvailable';
import getServiceUnavailable from './getServiceUnavailable';
import onePlatformCheckServicesAvailable from './one_platform/onePlatformCheckServicesAvailable';
import AppState from '../AppState';
import { checkActiveServiceStatus } from "./one_platform/onePlatformGetServiceQualification";
import onePlatformAlreadyActiveService from "./one_platform/onePlatformAlreadyActiveService";
/**
 * Retrieves the service qualification information for a given address.
 *
 * @param {MouseEvent} event - The click event object.
 *
 * @returns {Promise<void>} - A Promise that resolves when the service
 *                            qualification process is complete.
 */
const getAddressServiceQualification = (event) => __awaiter(void 0, void 0, void 0, function* () {
    event.preventDefault();
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const addressConfirmed = AppState.get('addressConfirmed');
    const { context } = drupalJsObjects;
    const addressTile = context.querySelector('#address-tile');
    const addressCheckProgress = context.querySelector('#address-check-progress');
    // Update the display to move to the next step.
    context.querySelector('#address-confirmation-2').appendChild(addressConfirmed);
    addressTile.remove();
    addressCheckProgress.style.display = 'block';
    // Check if selected address has any plans.
    const gnafId = addressConfirmed.getAttribute('data-address-id');
    // Display a series of messages to indicate relevant plans are being searched for.
    messageRotator();
    // Check plan eligibility for address.
    try {
        const result = yield getServiceQualification(gnafId);
        if (result && typeof result !== "boolean" && result.onePlatformServiceQualification) {
            AppState.set('addressCheckProgress', addressCheckProgress);
            if (checkActiveServiceStatus(result.onePlatformServiceQualification.qualificationResult)) {
                onePlatformAlreadyActiveService();
            }
            else {
                onePlatformCheckServicesAvailable(result.onePlatformServiceQualification);
            }
        }
        else if (result && typeof result !== "boolean" && result.serviceQualification) {
            const { serviceQualification, address, salesId, token } = result;
            AppState.set('salesId', salesId);
            AppState.set('token', token);
            AppState.set('addressCheckProgress', addressCheckProgress);
            checkServicesAvailable(serviceQualification, address);
        }
        else {
            getServiceUnavailable();
        }
    }
    catch (error) {
        console.log('Error:', error);
    }
});
export default getAddressServiceQualification;
